export interface ChangePasswordRequestDto {
  key: string;
  password: string;
  passwordVerify: string;
  verificationCode: string;
}

export interface SendChangePasswordLinkResponseDto {
  username: string;
  maskedPhone: string;
  maskedEmail: string;
  userType: UserTypes;
}

export interface SendChangePasswordLinkRequestDto {
  username: string;
  eCaptchaToken: string;
  eCaptchaCode:string
}

export enum UserTypes {
  FieldStaff = 1,
  AdministrativeStaff = 2,
  External = 3,
}
export interface SendChangePasswordVerificationCodeResponseDto {
  verificationSeconds: number;
}
